import { useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch } from 'react-redux';
import { t } from 'ttag';
import Btn from 'components/Btn/index.js';
import { hideTopNotification } from 'store/ducks/layout.js';
import useShallowEqualSelector from 'hooks/useShallowEqualSelector.js';
import IconExclamation from 'static/icons/exclamation.svg';
import IconCheck from 'static/icons/check.svg';
import IconXmark from 'static/icons/xmark.svg';
import IconCircleInfo from 'static/icons/circle-info.svg';
import IconBackend from 'static/icons/backend.svg';
import './index.scss';

const HeaderNotificationIcon = type => ({
    success: <IconCheck />,
    error: <IconExclamation />,
    warning: <IconCircleInfo />,
    backendProblem: <IconBackend />,
})[type];

const TopNotification = () => {
    const dispatch = useDispatch();
    const ref = useRef(null);
    const { text, type = '', visible, style } = useShallowEqualSelector(state => state.layout.topNotification);
    const id = 'top-notification';

    const onClickDismiss = () => {
        ref.current?.hidePopover();
        dispatch(hideTopNotification());
    };

    useEffect(() => { setTimeout(() => ref.current?.togglePopover(visible), 10); }, [visible]);

    return createPortal(
        <div
            ref={ref}
            id={id}
            className={`top-notification ${type || ''} ${visible ? 'visible' : ''}`}
            style={style}
            popover='manual'
            aria-live='polite'
        >
            <div className='icon-text-wrapper'>
                {HeaderNotificationIcon(type) || null}
                <span className='notification-text'>{text}</span>
            </div>
            <Btn
                onClick={onClickDismiss}
                variant='PLAIN'
                className='btn-close'
                title={t`(COMPONENT_TOP_NOTIFICATION)_BTN_CLOSE_TOOLTIP`}
                icon={<IconXmark />}
                popovertarget={id}
                popovertargetaction='hide'
            />
        </div>,
        document.getElementById('popup-layer'),
    );
};


export default TopNotification;
